import { useEffect } from 'react';

import { cx } from '@emotion/css';
import { Card, Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { doRemoveRedirectToLinkAccount } from 'src/actions';
import { useFindAccountStatus, useSubmittedAccountSelector } from 'src/hooks';
import { LinkAccountButton, MTypography } from 'src/lib';
import { BaseStyle, FlexDirection, Spacing } from 'src/styles';

export const LinkAccountPage = () => {
  const shouldRedirect = useSelector((state: any) => state.app.redirectToLinkAccount);

  const { account } = useSubmittedAccountSelector();
  const { isAnyDocumentRequested } = useFindAccountStatus({ skip: true });
  const dispatch = useDispatch();

  useEffect(() => {
    if (shouldRedirect) {
      dispatch(doRemoveRedirectToLinkAccount());
    }
  }, []);

  return (
    <Row className={Spacing.my48}>
      <Card>
        <Row gutter={[, 16]} justify='center' align='middle'>
          <Col span={24}>
            <MTypography variant='h3' weight='semibold'>
              Account Linking Error
            </MTypography>
          </Col>
          <Col span={24}>
            <MTypography variant='subtitle1'>
              Your new {account.customTypeLabel} account has been successfully created. However, we could not
              automatically link it to your existing username.
              {isAnyDocumentRequested
                ? ` Please click the button below to manually link your new ${account.customTypeLabel} account.`
                : ''}
            </MTypography>
          </Col>
          <Col span={24} className={cx(BaseStyle.level, FlexDirection.column)}>
            <LinkAccountButton centered />
          </Col>
        </Row>
      </Card>
    </Row>
  );
};
